module.exports = __webpack_public_path__ + "img/main.a8d72784.png";